import { isJson } from "./helpers";
import { notification } from "antd";
import { isSilent401Url, isTokenExpired, clearAuth } from "./login";

const codeMessage = {
  401: "Пользователь не авторизован",
  403: "Пользователь авторизован, но доступ запрещен.",
  404: "Запрос делается для записи, которая не существует",
  500: "На сервере произошла ошибка.",
};

// Бек на запрет доступа отвечает 403 с телом { code: "ACCESS_DENIED" };
// performRequest реджектит { status, ...body }, поэтому проверяем оба поля.
export const isAccessDeniedError = (err) =>
  Boolean(err) && err.status === 403 && err.code === "ACCESS_DENIED";

// Любой 403: performRequest реджектит { status }, axios — { response: { status } }.
export const isForbiddenError = (err) =>
  Boolean(err) && (err.status === 403 || err.response?.status === 403);

const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const errortext = codeMessage[response.status] || response.statusText;

  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};

function parseText(text) {
  return text.length ? (isJson(text) ? JSON.parse(text) : text) : {};
}

const defaultOptions = { credentials: "include" };

export default function performRequest(url, options) {
  const token = localStorage.getItem("token");
  if (token !== null) {
    options = {
      ...options,
      headers: { Authorization: "Bearer " + token },
    };
  }

  // handleForbidden: страница сама показывает отказ в доступе на любой 403
  const { handleForbidden, ...restOptions } = options || {};
  const newOptions = { ...defaultOptions, ...restOptions };

  if (
    newOptions.method === "POST" ||
    newOptions.method === "PATCH" ||
    newOptions.method === "PUT" ||
    newOptions.method === "DELETE"
  ) {
    if (
      !(newOptions.body instanceof FormData) &&
      !(newOptions.body instanceof URLSearchParams)
    ) {
      newOptions.headers = {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        ...newOptions.headers,
      };
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      newOptions.headers = {
        Accept: "application/json",
        ...newOptions.headers,
      };
    }
  }

  console.log("options", options);

  return fetch(url, newOptions)
    .then(checkStatus)
    .then((response) => response.text())
    .then((text) => parseText(text))
    .catch(async (err) => {
      console.error("request error", err);

      const { name: status, response } = err;

      if (!response) {
        notification.error({
          key: "requestFailedNotification",
          message: "Внимание!",
          description:
            "Не удалось загрузить данные. Попробуйте обновить страницу.",
        });
        return Promise.reject(err);
      }

      const silent = isSilent401Url(response.url);
      const responseText = await response.text();
      const responseJSON = parseText(responseText);

      if (silent) {
        return Promise.reject({ status, ...responseJSON });
      }

      if (status === 401) {
        if (isTokenExpired(localStorage.getItem("token"))) {
          clearAuth();
        }
        return Promise.reject({ status, ...responseJSON });
      }

      const rejection = { status, ...responseJSON };

      // Отсутствие прав страницы показывают сами (Alert) — общий тост не нужен.
      if (
        !isAccessDeniedError(rejection) &&
        !(handleForbidden && status === 403)
      ) {
        notification.error({
          key: "requestFailedNotification",
          message: "Внимание!",
          description:
            "Не удалось загрузить данные. Попробуйте обновить страницу.",
        });
      }

      return Promise.reject(rejection);
    });
}
